/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { SpaceObjectType } from '@ootk/src/main';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
export var JupiterTextureQuality;
(function (JupiterTextureQuality) {
    JupiterTextureQuality["POTATO"] = "512";
    JupiterTextureQuality["HIGH"] = "2k";
    JupiterTextureQuality["ULTRA"] = "4k";
})(JupiterTextureQuality || (JupiterTextureQuality = {}));
export class Jupiter extends CelestialBody {
    RADIUS = 69911;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    orbitalPeriod = 11.862 * 365.25 * 24 * 3600;
    meanDistanceToSun = 778340821;
    type = SpaceObjectType.GAS_GIANT;
    eci;
    color = PlanetColors.JUPITER;
    textureQuality = JupiterTextureQuality.POTATO;
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/jupiter${this.textureQuality}.jpg`;
    }
    getName() {
        return SolarBody.Jupiter;
    }
    useHighestQualityTexture() {
        this.textureQuality = JupiterTextureQuality.ULTRA;
        this.loadTexture();
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
    }
}
